import { PageValidationFunctions } from '../types';
import { withdrawReason, withdrawReasonSoft } from './withdrawReason';
import { withdrawDeclaration } from './withdrawDeclaration';

export const Withdraw: PageValidationFunctions = {
    withdrawReasonSoft,
    withdrawReason,
    withdrawDeclaration,
};
